const math = require('../utils/math');

export default class quantity {
  constructor() {
    this.input = '.input-quantity';
  }

  init() {
    this.triggerQuantity();
  }

  triggerQuantity() {
    $(document)
      .off('change.productQuantity', this.input)
      .on('change.productQuantity', this.input, (e) => {
        const $this = $(e.currentTarget);
        if ($this.closest('.add-to-cart-wrapper__experience').length) return;

        math.default.update(this.input, this.maxvalue);
        const valueInput = $this.val();

        const $thisSelect = $this.parents('.quantity-change').find('.quantity-select');
        let $productContainer = $this.closest('.product-detail');
        if (!$productContainer.length) {
          $productContainer = $this.closest('.product-quickview');
        }

        if ($productContainer.length) {
          $productContainer.attr('data-user-quantity-change', 'true');
        }

        $thisSelect.find(`option[value="${valueInput}"]`).prop('selected', true).trigger('change');

        $this.trigger('after:quantitychange', $this);
      });
  }
}
